import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import useGetVsic from '../../../../common/category/useGetVsic'
import { UseI18n } from '../../../../common/hooks/useI18n'
import { COMPANY_NON_BANK_TYPES, COMPANY_TYPES } from '../../../../utils/common'
import { selectCompanyInfo } from '../../../common/header/companyInfo/store/slice'
import { getDefaultVsic } from '../../helper'
import { changeIndustry, selectDefaultIndustry } from '../store/slice'
import { SelectCustomIndustry } from './IndustrySeclectCustom'

const getActiveDataOfDefault = (defaultIndustry, companyType) => {
  if (companyType === COMPANY_TYPES.BANK) {
    return COMPANY_TYPES.BANK
  }

  if (companyType === COMPANY_NON_BANK_TYPES.NON_BANK_FIC) {
    return COMPANY_NON_BANK_TYPES.NON_BANK_FIC
  }

  if (companyType === COMPANY_NON_BANK_TYPES.NON_BANK_FIO) {
    return COMPANY_NON_BANK_TYPES.NON_BANK_FIO
  }

  if (companyType === COMPANY_NON_BANK_TYPES.NON_BANK_LEA) {
    return COMPANY_NON_BANK_TYPES.NON_BANK_LEA
  }

  if (companyType === COMPANY_TYPES.SECURITIES) {
    return COMPANY_TYPES.SECURITIES
  }

  if (companyType === COMPANY_TYPES.LIFE_INSURANCE) {
    return COMPANY_TYPES.LIFE_INSURANCE
  }

  if (companyType === COMPANY_TYPES.NON_LIFE_INSURANCE) {
    return COMPANY_TYPES.NON_LIFE_INSURANCE
  }

  return defaultIndustry
}

export const DefaultIndustry = ({
  inputStyle,
  isDynamicReport,
  keySetting,
  setValue,
  setting,
}) => {
  const dispatch = useDispatch()
  const { vsics } = useGetVsic()
  const defaultIndustry = useSelector(selectDefaultIndustry)
  const { companyType, companyTypeOrigin, mainVsicId } =
    useSelector(selectCompanyInfo)
  const placeholder = UseI18n('companyAnalysis.SELECT_DEFAULT_INDUSTRY')

  const handleReset = () => {
    const defaultVsic = getDefaultVsic(vsics, mainVsicId)
    dispatch(
      changeIndustry({
        type: 'defaultIndustry',
        value: defaultVsic?.id,
      }),
    )
  }

  return (
    <>
      <Translate
        value={'companyAnalysis.industryAnalysis.DEFAULT_INDUSTRY'}
        style={{ width: isDynamicReport ? 150 : 'auto' }}
      />

      <SelectCustomIndustry
        data={
          isDynamicReport
            ? setting[keySetting]
            : getActiveDataOfDefault(
                defaultIndustry,
                companyTypeOrigin || companyType,
              )
        }
        vsics={vsics}
        companyType={companyTypeOrigin || companyType}
        keyItem="defaultIndustry"
        borderColor={'#00A8B5'}
        customWidthDropdown={186}
        inputStyle={inputStyle}
        keySettingDynamicReport={keySetting}
        setValueDynamicReport={setValue}
        placeholder={placeholder}
        handleReset={handleReset}
        isDynamicReport={isDynamicReport}
      />
    </>
  )
}
